export const RequiredField = () => {
  return <span className="font-weight-bold required-field"> *</span>;
};
export default RequiredField;
